<template>
  <component
    :is="component"
    :area="areaProp"
    :articles="posts"
    :title="title"
    @on-click-item="sendAnalytics"
  />
</template>

<script lang="ts">
  import type { Component, PropType } from 'vue';
  import type { IContentTaxonomyPosts, TTaxonomyPosts } from '~/types/components/TaxonomyPosts';
  import ArticlesCarousel from '~/components/ArticlesCarousel/ArticlesCarousel.vue';
  import AccentCardsWrapp from '~/components/AccentCardsWrapp.vue';
  import type { TArticle } from '~/types/common';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';

  export default defineNuxtComponent({
    name: 'TaxonomyPosts',
    provide() {
      return {
        eventElement: () => `Посты таксономий`,
      };
    },

    inject: {
      area: {
        default() {
          return () => '';
        },
      },

      areaAnalytics: {
        default() {
          return () => '';
        },
      },

      eventName: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      elem: {
        type: Object as PropType<IContentTaxonomyPosts>,
        required: true,
      },
    },

    computed: {
      taxonomyPosts(): TTaxonomyPosts {
        return this.elem?.attributes;
      },

      posts(): Array<TArticle> {
        return this.taxonomyPosts?.posts;
      },

      title(): string {
        return this.taxonomyPosts?.title;
      },

      isCarousel(): boolean {
        return this.taxonomyPosts.posts?.length > 2;
      },

      component(): Component {
        return this.isCarousel ? ArticlesCarousel : AccentCardsWrapp;
      },

      areaProp(): string {
        return this.area?.() ?? '';
      },

      currentSlug(): string {
        return getSlugFromUrl(this.$route.fullPath);
      },
    },

    methods: {
      // Функция выбора карточки таксономии
      sendAnalytics(article: TArticle, orderNumber?: number) {
        const slugRefferer = getSlugFromUrl(article.url);

        this.$sendYandexMetrika({
          level1: 'Выбор материала_коллекция постов',
          level4: slugRefferer,
          level5: orderNumber,
          level6: this.title,
          level8: this.areaProp === 'home' ? 'главная' : 'комментарии',
        });
      },
    },
  });
</script>
